module.exports = __webpack_public_path__ + "img/00041.fe01da22.webp";